import { useQuery } from '@tanstack/react-query'
import { useZone } from '~/team_tools/components/timezone'
import { JsonRpcError } from '~/types'
import { EarningFeeHistory } from '../types'

/** `days` for the last N days; `from`/`to` or `monthly` from the dashboard's window. */
export const useStatisticEarningFeeHistory = ({ days = 30, ...window }: { days?: number; [key: string]: any } = {}) => {
    const [zone] = useZone()
    return useQuery<EarningFeeHistory, JsonRpcError>({
        queryKey: ['statistic.earning_fee.history', days, zone, window],
        queryFn: async () => {
            const res = await fetch('/rpc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'gameapi.statistic.earnings_fee.history',
                    // The zone by name, not the device's offset: the buckets are
                    // the days of the zone the shell names, each with its own
                    // offset, the same way every other dashboard chart counts.
                    params: { days, tz: zone, ...window },
                }),
            })
            const data = await res.json()
            if (data.error) {
                throw data
            } else {
                return data.result
            }
        },
        retry: false,
    })
}
